import DialogContent from '@mui/material/DialogContent';
import classNames from 'classnames';
import type { ReactNode } from 'react';

import styles from './portal-dialog.module.css';

interface PortalDialogContentProps {
  className?: string;
  children: ReactNode;
}

export function PortalDialogContent({
  className,
  children,
}: PortalDialogContentProps) {
  return (
    <div className={styles['dialog-content']}>
      <DialogContent className={classNames('overflow-visible', className)}>
        {children}
      </DialogContent>
    </div>
  );
}
